exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-account[data-v-2593308c]{font-size:18px;color:#52a399}.modal-time[data-v-2593308c]{font-size:16px;font-weight:700}.modal-summary[data-v-2593308c]{font-size:14px}", ""]);

// exports
